import { useEffect, useState } from 'react';
import { api, ApiError, type BillsView } from '../api';
import { Empty, Header, Segmented, Tabs, WalletId } from '../components/ui';

const TYPES = [
  { key: 'all', label: '全部' },
  { key: 'deposit', label: '充值' },
  { key: 'withdraw', label: '提现' },
  { key: 'fx', label: '换汇' },
  { key: 'transfer', label: '转账' },
];

const RANGES = [
  { key: 'today', label: '今天' },
  { key: '7d', label: '近7天' },
  { key: '30d', label: '近30天' },
  { key: 'all', label: '全部' },
];

export function BillsPage({ walletId }: { walletId?: string }) {
  const [type, setType] = useState('all');
  const [range, setRange] = useState('all');
  const [data, setData] = useState<BillsView | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setData(null);
    setError(null);
    api
      .bills(type, range)
      .then((result) => {
        if (!cancelled) setData(result);
      })
      .catch((err: ApiError) => {
        if (!cancelled) setError(err.message);
      });
    return () => {
      cancelled = true;
    };
  }, [type, range]);

  return (
    <div className="app">
      <Header title="账单" />
      {walletId ? <WalletId id={walletId} /> : null}
      <div className="body">
        <Tabs tabs={TYPES} active={type} onChange={setType} />
        <Segmented options={RANGES} active={range} onChange={setRange} />

        {error ? <div className="error">{error}</div> : null}

        {!data ? (
          <div className="loading">加载中…</div>
        ) : data.items.length === 0 ? (
          <Empty text={data.emptyText} />
        ) : (
          <div className="list">
            {data.items.map((item) => (
              <div className="item" key={item.id}>
                <div className="top">
                  <b>
                    {item.typeLabel} · {item.title}
                  </b>
                  <span className={`amount ${item.direction}`}>{item.signedAmountText} USDT</span>
                </div>
                <div className="meta">
                  {new Date(item.createdAt).toLocaleString('zh-CN')} · 手续费 {item.feeText} ·{' '}
                  {item.statusText}
                </div>
              </div>
            ))}
          </div>
        )}

        {data ? (
          <div className="bill-totals">
            <span>出款：{data.totals.outText} USDT</span>
            <span>入款：{data.totals.inText} USDT</span>
            <span>总额：{data.totals.netText} USDT</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
